import request from '@/common/utils/request'
// 获取验证码
export function getCodeRequest (data) {
  return request({
    url: process.env.HTTP_LOGIN_SERVER + 'auth/v2/mobile/sendmobileauthcode',
    method: 'get',
    params: {
      ...data
    }
  })
}
// 乘客登录获取token
export function loginRequest (data) {
  return request({
    url: process.env.HTTP_LOGIN_SERVER + 'auth/v2/login/passenger/mobile',
    method: 'post',
    data
  })
}
// 获取图片验证码
export function getImgCodenRequest (data) {
  return request({
    url: process.env.HTTP_LOGIN_SERVER + 'auth/v2/imgcode/getimagecode',
    method: 'post',
    data
  })
}
// 验证图片验证码
export function confirmImgCodenRequest (data) {
  return request({
    url: process.env.HTTP_LOGIN_SERVER + 'auth/v2/imgcode/verifyimagecode',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/data/api/common/Login/Login.js